export const environment = {
  production: true,
  graphURI: window['graphURI'],
  api: window['api'],
  devBaseUrl: 'api.dv.crmp.org'
};
